module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURUdwTP///////////////////////////////////////////xR6XWcAAAALdFJOUwCAf2Fma3BcdXpXxP8q3AAAAF5JREFUKM9jYBhKgBHGEIDS2hMgNOcmmMAOCN29ESrAtDsBRLHthmlhkN4KIqM3Ikzd7cDAwIJQADRlMwOD9UZki3cXsO9WQHaK9K7Vm1DdthtVAVDJJnTnKzAMNQAAIOARy4G52RMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-down.png
// module id = V/5H
// module chunks = 1